import Button from '@/common/components/base/button/Button';
import Input from '@/common/components/base/input/base/Input';
import { PercentageInputType } from '@/common/components/base/percentageInput/percentageInput.type';
import Typography from '@/common/components/base/typography/Typography';
import React, { ChangeEventHandler } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import { Box, Flex } from 'styled-system/jsx';
import AddIcon from '@/common/assets/icons/add.svg?react';
import MinusIcon from '@/common/assets/icons/minus.svg?react';

const PercentageInput: React.FC<PercentageInputType> = ({
  label,
  percentage,
  placeHolder,
  maxPercentage,
  name,
  rules,
  defaultValue = 0,
}) => {
  const { control } = useFormContext();
  const controller = useController({
    rules,
    control,
    name,
    defaultValue,
  });

  const { field, fieldState } = controller;
  const errorMessage = fieldState.error?.message;
  const handleIncrease = () => {
    if (maxPercentage && maxPercentage > +field.value)
      field.onChange(+field.value + percentage);
  };

  const handleDecrease = () => {
    if (+field.value > 0) field.onChange(+field.value - percentage);
  };

  const inputOnChange: ChangeEventHandler<HTMLInputElement> = (e) => {
    field.onChange(e.target.value);
  };

  return (
    <Box position="relative">
      <Typography textStyle="b2" position="absolute">
        {label}
      </Typography>
      <Flex alignItems="center" gap={8}>
        <Button
          variant="outlined"
          type="reset"
          onClick={handleIncrease}
          fontSize={20}
          px={10}
          py={12}
        >
          <AddIcon width={24} height={24} />
        </Button>
        <Input
          inputRef={field.ref}
          inputProps={{
            value: field.value,
            placeholder: placeHolder,
            textAlign: 'center',
            onChange: inputOnChange,
            width: '100%',
            type: 'reset',
          }}
          direction="rtl"
          errorMessage={errorMessage}
        />
        <Button
          px={10}
          py={12}
          variant="outlined"
          type="reset"
          color="common"
          onClick={handleDecrease}
          fontSize={20}
        >
          <MinusIcon width={24} height={24} />
        </Button>
      </Flex>
    </Box>
  );
};
export default PercentageInput;
